import { render, staticRenderFns } from "./main_face.vue?vue&type=template&id=2f78c736&scoped=true"
import script from "./main_face.vue?vue&type=script&lang=js"
export * from "./main_face.vue?vue&type=script&lang=js"
import style0 from "./main_face.vue?vue&type=style&index=0&id=2f78c736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f78c736",
  null
  
)

export default component.exports